import { memo } from "react";

type StageRowProps = {
  label: string;
  percentage: number;
  total: number;
  isError: boolean;
  isLast?: boolean;
};

const NUMBER_FORMATTER = new Intl.NumberFormat();

export const StageRow = memo(
  ({ label, percentage, total, isError, isLast = false }: StageRowProps) => {
    const displayPercentage = isError ? "--" : `${percentage}%`;
    const displayTotal = isError ? "--" : NUMBER_FORMATTER.format(total);

    return (
      <div className="tw-contents">
        <span className="tw-col-span-2 tw-font-sans tw-text-xs/tight tw-font-normal tw-text-blue">
          {label}
        </span>

        <div
          className={`tw-h-2 tw-overflow-hidden tw-rounded-full tw-bg-blue-500/20 ${!isLast ? "tw-mb-2" : ""}`}
        >
          <div
            className="tw-h-full tw-rounded-full tw-bg-[#610CFF] tw-transition-all tw-duration-300"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <span
          className={`tw-font-sans tw-text-right tw-text-xs tw-font-normal tw-text-blue tw-whitespace-nowrap ${!isLast ? "tw-mb-2" : ""}`}
        >
          {displayPercentage} ({displayTotal} users)
        </span>
      </div>
    );
  },
);
